export default "__VITE_ASSET__Dwepl5Dy__"